import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Icon from './Icon';

const StyledIcon = styled(Icon)`
  fill: none;
`;

const Morning = (props) => {
  const { color, ...rest } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledIcon viewBox="0 0 20 20" {...rest}>
      <path
        d="M10 4.167V2.5M1.667 10.833h1.666M4.167 5L5 5.833M15.833 5L15 5.833M18.45 10.833h-1.783M10 12.5v4.167M11.667 14.167L10 12.5l-1.667 1.667M6.667 10.833a3.333 3.333 0 0 1 6.666 0"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledIcon>
  );
};

Morning.propTypes = {
  color: PropTypes.string
};

Morning.defaultProps = {
  color: 'var(--color-text-primary)'
};

export default Morning;
